"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const guards_1 = require("./guards");
const encode_1 = require("./encode");
const decode_1 = __importDefault(require("./decode"));
class Bucket {
    constructor(b, position) {
        this.bytes = (b !== null && b !== void 0 ? b : new ArrayBuffer(0));
        this.position = (position !== null && position !== void 0 ? position : 0);
    }
    append(slice, elem) {
        const result = new Uint8Array(slice.byteLength + elem.byteLength);
        result.set(new Uint8Array(slice));
        result.set(new Uint8Array(elem), slice.byteLength);
        return result.buffer;
    }
    readBoolean() {
        return this.readUint8() > 0;
    }
    writeBoolean(v) {
        this.writeUint8(v ? 1 : 0);
    }
    readN(n) {
        const result = new Uint8Array(this.bytes, this.position, n);
        this.position += n;
        return result;
    }
    readInt8() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 1;
        return dv.getInt8(0);
    }
    writeInt8(n) {
        const d = new Uint8Array(1);
        const dv = new DataView(d.buffer);
        dv.setInt8(0, n);
        this.write(d);
    }
    readUint8() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 1;
        return dv.getUint8(0);
    }
    writeUint8(n) {
        const d = new Uint8Array(1);
        const dv = new DataView(d.buffer);
        dv.setUint8(0, n);
        this.write(d);
    }
    readInt16() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 2;
        return dv.getInt16(0, true);
    }
    writeInt16(n) {
        const d = new Uint8Array(2);
        const dv = new DataView(d.buffer);
        dv.setInt16(0, n, true);
        this.write(d);
    }
    readUint16() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 2;
        return dv.getUint16(0, true);
    }
    writeUint16(n) {
        const d = new Uint8Array(2);
        const dv = new DataView(d.buffer);
        dv.setUint16(0, n, true);
        this.write(d);
    }
    readInt32() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 4;
        return dv.getInt32(0, true);
    }
    writeInt32(n) {
        const d = new Uint8Array(4);
        const dv = new DataView(d.buffer);
        dv.setInt32(0, n, true);
        this.write(d);
    }
    readUint32() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 4;
        return dv.getUint32(0, true);
    }
    writeUint32(n) {
        const d = new Uint8Array(4);
        const dv = new DataView(d.buffer);
        dv.setUint32(0, n, true);
        this.write(d);
    }
    readInt64() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 8;
        return dv.getBigInt64(0, true);
    }
    writeInt64(n) {
        const d = new Uint8Array(8);
        const dv = new DataView(d.buffer);
        dv.setBigInt64(0, n, true);
        this.write(d);
    }
    readUint64() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 8;
        return dv.getBigUint64(0, true);
    }
    writeUint64(n) {
        const d = new Uint8Array(8);
        const dv = new DataView(d.buffer);
        dv.setBigUint64(0, n, true);
        this.write(d);
    }
    readFloat32() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 4;
        return dv.getFloat32(0, true);
    }
    writeFloat32(n) {
        const d = new Uint8Array(4);
        const dv = new DataView(d.buffer);
        dv.setFloat32(0, n, true);
        this.write(d);
    }
    readFloat64() {
        const dv = new DataView(this.bytes, this.position);
        this.position += 8;
        return dv.getFloat64(0, true);
    }
    writeFloat64(n) {
        const d = new Uint8Array(8);
        const dv = new DataView(d.buffer);
        dv.setFloat64(0, n, true);
        this.write(d);
    }
    readString() {
        const n = this.readInt32();
        if (n === -1) {
            return '';
        }
        const d = this.readN(n);
        const decoder = new TextDecoder();
        return decoder.decode(d);
    }
    // write string with length
    writeString(s) {
        const encoder = new TextEncoder();
        const data = encoder.encode(s);
        if (data.byteLength === 0) {
            this.writeInt32(-1);
            return;
        }
        this.writeInt32(data.byteLength);
        this.write(data);
    }
    readByteString() {
        const n = this.readInt32();
        if (n === -1) {
            return new Uint8Array();
        }
        return this.readN(n);
    }
    writeByteString(b) {
        if (b.byteLength === 0) {
            this.writeInt32(-1);
            return;
        }
        this.writeInt32(b.byteLength);
        this.write(b);
    }
    readStringBytes(n) {
        const d = this.readN(n);
        const decoder = new TextDecoder();
        return decoder.decode(d);
    }
    // write string without length
    writeStringBytes(s) {
        const encoder = new TextEncoder();
        const data = encoder.encode(s);
        this.write(data);
    }
    readStruct(w) {
        if (guards_1.isDecoder(w)) {
            this.position = w.decode(this.bytes, this.position);
        }
        else {
            this.position = decode_1.default({
                bytes: this.bytes,
                instance: w,
                position: this.position
            });
        }
    }
    writeStruct(instance) {
        let d;
        if (guards_1.isEncoder(instance)) {
            d = instance.encode();
        }
        else {
            d = encode_1.encode({ instance });
        }
        this.write(d);
    }
    readDate() {
        const dv = new DataView(this.bytes, this.position);
        const value = dv.getBigInt64(0, true);
        this.position += 8;
        return new Date(Number(value - BigInt(116444736000000000)) / 1e4);
    }
    writeDate(date) {
        const b = new Uint8Array(8);
        const dv = new DataView(b.buffer);
        const value = BigInt(date.getTime()) * BigInt(1e4) + BigInt(116444736000000000);
        dv.setBigInt64(0, value, true);
        this.write(b);
    }
    write(d) {
        this.bytes = this.append(this.bytes, d);
    }
}
exports.default = Bucket;
